import { render, staticRenderFns } from "./LotNumberOfBids.vue?vue&type=template&id=87c635bc&scoped=true&"
import script from "./LotNumberOfBids.vue?vue&type=script&lang=js&"
export * from "./LotNumberOfBids.vue?vue&type=script&lang=js&"
import style0 from "./LotNumberOfBids.vue?vue&type=style&index=0&id=87c635bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87c635bc",
  null
  
)

export default component.exports